interface Props {
  activeColor: string;
}

const InterestLevelIcon = ({ activeColor }: Props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="bgGlow"
          x1="20"
          y1="16"
          x2="108"
          y2="112"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7C3AED" />
          <stop offset="0.5" stopColor="#06B6D4" />
          <stop offset="1" stopColor="#22C55E" />
        </linearGradient>

        <linearGradient
          id="heartStroke"
          x1="34"
          y1="28"
          x2="96"
          y2="92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A78BFA" />
          <stop offset="0.5" stopColor="#22D3EE" />
          <stop offset="1" stopColor="#4ADE80" />
        </linearGradient>

        <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="4" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <rect x="12" y="12" width="104" height="104" rx="28" fill="#0B1220" />
      <rect
        x="12"
        y="12"
        width="104"
        height="104"
        rx="28"
        stroke="url(#bgGlow)"
        strokeWidth="2"
        opacity="0.5"
      />

      <circle
        cx="64"
        cy="64"
        r="38"
        stroke="url(#bgGlow)"
        strokeWidth="2"
        opacity="0.18"
      />

      <path
        d="M64 89C63.2 89 62.4 88.7 61.8 88.1L41.2 68.6C35.3 63 35.3 53.8 41 48.1C46.5 42.7 55.3 42.3 61.2 47L64 49.2L66.8 47C72.7 42.3 81.5 42.7 87 48.1C92.7 53.8 92.7 63 86.8 68.6L66.2 88.1C65.6 88.7 64.8 89 64 89Z"
        stroke="url(#heartStroke)"
        strokeWidth="4"
        strokeLinejoin="round"
        filter="url(#softGlow)"
      />

      <path
        d="M52 58H43"
        stroke="#67E8F9"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M76 52L83 45"
        stroke="#A78BFA"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M74 71L84 79"
        stroke="#4ADE80"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M58 76L53 86"
        stroke="#22D3EE"
        strokeWidth="3"
        strokeLinecap="round"
      />

      <circle cx="43" cy="58" r="4" fill="#67E8F9" />
      <circle cx="83" cy="45" r="4" fill="#A78BFA" />
      <circle cx="84" cy="79" r="4" fill="#4ADE80" />
      <circle cx="53" cy="86" r="4" fill="#22D3EE" />

      <path
        d="M50 64H58L62 57L67 72L71 64H78"
        stroke="#E0F2FE"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter="url(#softGlow)"
      />
    </svg>
  );
};

export default InterestLevelIcon;
